import React from 'react';

import {
    Col,
    Container,
    Row,
} from '@zillow/zrs-comet';

import LeadGuarantee from './components/LeadGuarantee';

const LearnMoreLeadGuaranteePage = () => {
    return (
        <Container className="LearnMoreLeadGuaranteePage" marginTop="xs">
            <Row>
                <Col xs="12">
                    <LeadGuarantee />
                </Col>
            </Row>
        </Container>
    );
};

LearnMoreLeadGuaranteePage.propTypes = {};

LearnMoreLeadGuaranteePage.defaultProps = {};

export default LearnMoreLeadGuaranteePage;
